import IconWithTooltip from "components/IconWithTooltip";
import { ReactComponent as Info } from "icons/info-new-rows.svg";
import { string } from "prop-types";

const InfoIcon = ({ tooltipText }) => {
  return (
    <IconWithTooltip
      icon={<Info data-testid="info-icon" />}
      tooltipText={tooltipText}
    />
  );
};

InfoIcon.propTypes = {
  tooltipText: string.isRequired,
};

export default InfoIcon;
